import {
    Component
    , Input
    , Output
    , EventEmitter
    , HostListener
    , OnInit
    , OnChanges
    , SimpleChanges
} from '@angular/core';

@Component({
    moduleId: module.id,
    selector: 'input-number',
    templateUrl: 'input-number.html'
})
export class InputNumberComponent implements OnInit, OnChanges {

    @Input() cssClass: string = 'form-control';
    @Input() cssStyle;
    @Input() useDot: boolean = false;
    @Input() allowDecimal: boolean = false;
    @Input() allowMinus: boolean = false;
    @Input() allowPaste: boolean = true;
    @Input() allowZeroStart: boolean = false;
    @Input() ngModelValue: any;
    @Input() placeholder: string = "";
    @Input() disabled: boolean = false;
    @Input() readOnly: boolean = false;
    @Input() inputId: string;
    
    @Output() ngModelValueChange = new EventEmitter();

    innerValue: string = "";

    private allowedCharCodes: number[] = new Array<number>();
    private allowedKeyCodes: number[] = new Array<number>();
    private keyCodeOk: boolean = false;

    ngOnInit(): void {
        this.allowedCharCodes = [48, 49, 50, 51, 52, 53, 54, 55, 56, 57]; //numeri
        if (this.allowMinus) this.allowedCharCodes.push(45); //segno -
        if (this.allowDecimal) {
            if (this.useDot) this.allowedCharCodes.push(46); //punto
            else this.allowedCharCodes.push(44); //virgola
        }

        this.allowedKeyCodes = ([8, 46, 127]); //delete, backspace
        this.allowedKeyCodes = this.allowedKeyCodes.concat([37, 39]); //destra, sinistra
        this.allowedKeyCodes = this.allowedKeyCodes.concat([16, 17]); //shift, Ctrl (Firefox);
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes && (changes["ngModelValue"])) {
            if (this.ngModelValue != null && this.ngModelValue != undefined) {
                if (!this.allowZeroStart) {
                    let n = +this.ngModelValue;
                    this.innerValue = n.toString();
                }
                else
                    this.innerValue = this.ngModelValue;
                if (!this.useDot) this.innerValue = this.innerValue.replace(".", ",");
            }
            else this.innerValue = "";
        }
    }

    @HostListener('keydown', ['$event'])
    keydown(e) {
        let paste: boolean = (e.ctrlKey && e.keyCode == 86) || (e.shiftKey && e.keyCode == 45); //(Firefox);
        this.keyCodeOk = paste || this.allowedKeyCodes.indexOf(e.keyCode) > -1;
        return true;
    }

    @HostListener('keypress', ['$event'])
    keypress(e) {
        let ok: boolean = this.keyCodeOk || this.allowedCharCodes.indexOf(e.charCode) > -1;
        let decimalSign: number = this.useDot ? 46 : 44;
        if (ok && e.charCode == decimalSign) ok = e.target.value.indexOf(String.fromCharCode(decimalSign)) < 0;
        this.keyCodeOk = false;
        return ok;
    }

    @HostListener('paste', ['$event'])
    paste(e) {
        e.preventDefault();
        if (this.allowPaste) {
            let pastedData: string = e.clipboardData.getData('Text');
            if (pastedData) pastedData = pastedData.trim().replace(",", ".");
            if (isFinite(+pastedData) && !isNaN(+pastedData)) {
                let start: number = e.target.selectionStart;
                let end: number = e.target.selectionEnd;
                let num: string = this.useDot ? pastedData : pastedData.replace(".", ",");
                let final: string = e.target.value.substring(0, start) + num + e.target.value.substring(end, e.target.value.length);
                let sepCount: number = 0;
                if (this.useDot) sepCount = (final.split(".").length - 1);
                else sepCount = (final.split(",").length - 1)

                let max = this.allowDecimal ? 1 : 0;
                if (sepCount <= max) e.target.value = final;
            }
        }
    }

    innerValueChange(e) {
        if (e && e.trim() != "") {
            e = e.replace(",", ".");
            if (!isNaN(e)) this.ngModelValueChange.emit(e);
            else this.ngModelValueChange.emit(null);
        }
        else this.ngModelValueChange.emit(null);
    }
}


// WEBPACK FOOTER //
// ./src/angular_library/components/input-number/input-number.component.ts